// extracted by mini-css-extract-plugin
export default {"boxUrl":"PopupApiContent_boxUrl__fEIMl","label":"PopupApiContent_label__iLi+W","body":"PopupApiContent_body__FoMPI","btnsBody":"PopupApiContent_btnsBody__gr7eS"};